<template>
  <div>
    <b-card>
      <b-media right-align>
        <b-media-body class="ml-3" align="left">
          <h4 class="mt-0">대표이사 인사말</h4>
          <p>
            광물자원사업은 산업 기초 부분에 매우 중요한 역할을 하고 있으나,
            그 지역에서 바로 쓰이는 게 아니라서 국민들이 피부로 느끼지 못하는 업종 중 하나입니다.
          </p>
          <p>
            우리나라도 광물 소비가 전 세계 3~4위에 이를 정도의 대량 소비를 하고 있지만 자급자족하는 광물은 별로 없고 대부분 해외수입에 의존하고 있습니다.
            현재 우리나라에서 자급자족하는 거의 유일한 광물은 석회석입니다.
          </p>
          <p>
            저희 한흥실업은 석회석 및 백운석 원석을 생산하는 업체로서 1980년대부터 석회석을 동물사료에 쓰기 시작한 최초의 회사 중 하나이며
            현재는 동물사료와 동물비타민, 보도 블럭, 테라죠, 타일, 미장재 토양정화제 등 다양한 용도로 제품을 출하하고 있습니다.
          </p>
          <p>
            석회석은 전세계적으로 약 5000종에 쓰인다고 알려져 있으며 우리나라에서도 산업용, 화학용, 시멘트용, 사료용, 비료, 유리, 세라믹, 플라스틱 등 다양한 분야에 쓰이고 있습니다.
            한흥실업은 40년 여 간의 경험을 바탕으로 사회에 이바지하는 기업이 되겠습니다.
          </p>
          <p align="right">
            대표이사 <b> 정 문 희 </b>
          </p>
        </b-media-body>
      </b-media>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Greeting'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Greeting.vue